export const locale = {
    lang: 'fr',
    data: {
        SAMPLE: {
            HELLO: 'Bienvenue au HaulierMagic!'
        }
    }
};
